<div class="card mb-3 border-0 d-flex align-items-center">
    <img class="card-img-top" style="width: 80%;" src="/assets/images/payment.png" alt="Card image cap">
    <div class="card-body">
        <h1 class="card-title mb-0">Site updating, please revisit soon.</h1>
        <p style="font-size: 16px;" class="card-text mb-0">Please contact with your admin.</p>
        <p style="font-size: 16px;" class="card-text">Thanks</p>
    </div>
</div>